import React from 'react';
import OwnerRepositories from './OwnerRepositories';

const RepositoriesModalContent = ({
  numOfFreeSlots,
  providerConfig,
  setSelected,
  orgRepositories,
  selected,
  isOnboarding,
  azureOrganizationName = null,
  selectedOrg,
  rowsPerPage,
  page,
  setPage,
  total,
  pageParams,
  setPageParams,
  setLoading,
  term,
  unselectedForNewRepos,
  setUnselectedForNewRepos,
  isGithubFetchAllRepoTypesFF,
  isBitbucket,
  hasNoActiveRepos,
  hasNoGitOrgs
}) => {
  const newRepositories = orgRepositories.filter(({ isNew }) => isNew);

  return (
    <OwnerRepositories
      numOfFreeSlots={numOfFreeSlots}
      providerConfig={providerConfig}
      selectedOrg={selectedOrg}
      ownerName={azureOrganizationName || selectedOrg}
      key={selectedOrg}
      repositories={orgRepositories}
      newRepositories={newRepositories}
      isOnboarding={isOnboarding}
      setSelected={setSelected}
      selected={selected}
      rowsPerPage={rowsPerPage}
      page={page}
      setPage={setPage}
      total={total}
      pageParams={pageParams}
      setPageParams={setPageParams}
      setLoading={setLoading}
      term={term}
      unselectedForNewRepos={unselectedForNewRepos}
      setUnselectedForNewRepos={setUnselectedForNewRepos}
      isGithubFetchAllRepoTypesFF={isGithubFetchAllRepoTypesFF}
      isBitbucket={isBitbucket}
      hasNoActiveRepos={hasNoActiveRepos}
      hasNoGitOrgs={hasNoGitOrgs}
    />
  );
};

export default RepositoriesModalContent;
